import { useMemo } from "react";
import GenericAutocomplete from "../../components/GenericAutocomplete";
import { CargoType } from "./types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCargoTypes } from "../../ducks/app/cargo-types/selectors";

interface CargoTypesSelectorProps {
  value: CargoType;
  onValueChange: (v: CargoType) => void;
}

const CargoTypesSelector = ({
  value,
  onValueChange,
}: CargoTypesSelectorProps) => {
  const { t } = useTranslation(["types", "stopPage"]);
  const driverCargoTypes = useSelector(selectCargoTypes);
  const options = useMemo(
    () =>
      driverCargoTypes.map((id) => ({ id, label: t("types:type", { context: id }) })),
    [t, driverCargoTypes]
  );
  return (
    <GenericAutocomplete
      options={options}
      value={value}
      label={t("stopPage:cargoType")}
      onChange={(v) => v && onValueChange(v)}
    />
  );
};

export default CargoTypesSelector;
